import { Flag } from './flag.model';

export const FLAGS: Flag[] = [
	{ country: 'de', languageCode: 'de', language: 'Deutsch' },
	{ country: 'gb', languageCode: 'en', language: 'English' },
	{ country: 'nl', languageCode: 'nl', language: 'Nederlands' },
	{ country: 'pl', languageCode: 'pl', language: 'Polski' },
	{ country: 'fr', languageCode: 'fr', language: 'Français' },
	{ country: 'tr', languageCode: 'tr', language: 'Türk' },
];





// WEBPACK FOOTER //
// ./src/app/login/models/mock-flags.ts